import type { TestBlock } from '@/types/report-payload';

import type { ReportFootnotePlan } from '../footnotes';
import type { RenderableSection } from '../pagination/types';
import type { ReportData } from '../types';
import { getCustomSectionById } from '@/lib/report-sections';
import StandaloneRichText from './StandaloneRichText';
import StandaloneSectionTitle from './StandaloneSectionTitle';
import StandaloneTestsRenderer from './StandaloneTestsRenderer';

interface StandaloneReportSectionProps {
    section: RenderableSection;
    data: ReportData;
    idPrefix?: string;
    blocksOverride?: TestBlock[];
    measureBlocks?: boolean;
    footnotePlan?: ReportFootnotePlan;
}

export default function StandaloneReportSection({
    section,
    data,
    idPrefix = '',
    blocksOverride,
    measureBlocks = false,
    footnotePlan,
}: StandaloneReportSectionProps) {
    const isSplit = Boolean(section.isSplit);
    const hideTitle = Boolean(section.hideTitle);
    const shouldRenderId = !isSplit;

    const sectionData =
        (data[section.id as keyof ReportData] as { content?: string } | undefined) ??
        getCustomSectionById(data, section.id);
    const contentToRender =
        section.contentOverride !== undefined ? section.contentOverride : sectionData?.content;

    return (
        <div
            id={shouldRenderId ? `${idPrefix}section-${section.id}` : undefined}
            className="relative mb-6"
        >
            {!hideTitle && <StandaloneSectionTitle section={section} data={data} />}

            {section.id === 'tests' ? (
                <StandaloneTestsRenderer
                    data={data}
                    blocks={blocksOverride || section.blocksOverride}
                    measureBlocks={measureBlocks}
                    footnotePlan={footnotePlan}
                />
            ) : (
                <StandaloneRichText content={contentToRender} />
            )}
        </div>
    );
}
